export default __webpack_public_path__ + "static/media/new-stories-disabled.d34a3e75.svg";